import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobMatchQueryFilter } from 'src/app/core/models/jobMatchQueryFilter';
import { JobMatchAction } from 'src/app/core/models/jobMatchAction';
import { AssociateCandidateQueryFilter } from 'src/app/public/app/models/associateCandidatesQueryFilter';
import { AssociateCandidateDisplayQueryFilter } from 'src/app/public/app/models/associateCandidateDisplayQueryFilter';
import { MatchedCandidatesContainer } from './matched-candidates-infinite-scroll-container';

import { JobService } from 'src/app/core/services/job.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { GenericService } from 'src/app/core/services/generic.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { JobMatchActionsService } from 'src/app/core/services/job-match-actions.service';
import { RequisitionService } from 'src/app/core/services/requisition.service';
import { FourDotFiveDateFormatPipe } from 'src/app/core/pipes/four-dot-five-date-format.pipe';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { AssociateCandidatesActionsModalComponent } from './associate-candidates-actions-modal/associate-candidates-actions-modal.component';
import { CandidateSendOutreachEmailModalComponent } from '../candidate-send-outreach-email-modal/candidate-send-outreach-email-modal.component';

declare var $: any;

@Component({
  selector: 'app-associate-candidates',
  templateUrl: './associate-candidates.component.html',
  styleUrls: ['./associate-candidates.component.css'],
  providers: [FourDotFiveDateFormatPipe]
})
export class AssociateCandidatesComponent implements OnInit, AfterViewInit {

  @Input() jobId: any;
  @Input() clientOrBuName: any;
  @Input() corporateId: any;
  @Input() clientOrBuId: any;
  @Input() isSharedRequisition: any;
  @Input() resumeRequiredForWorkflow: any;
  @Output() saveCallback = new EventEmitter<void>();

  MESSAGECONSTANTS = MESSAGECONSTANTS;

  jobDetails: any;
  associateCandidatesDefaultFilter: any = {};
  associateCandidatesDefaultFilterCopy: any = {};
  matchedCandidatesContainer: MatchedCandidatesContainer = null;
  createJobMatchesObject: any = null;
  minimumScoreSliderPadding = 0;
  maximumScoreSliderPadding = 100;
  maximumScoreSliderTopPosition = 0;
  defaultPageSize = 18;
  warningModal: any;

  lastModifiedOptions = [
    { text: 'Any Time', value: 0 },
    { text: '1 day', value: 1 },
    { text: '2 days', value: 2 },
    { text: '3 days', value: 3 },
    { text: '1 week', value: 7 },
    { text: '2 weeks', value: 14 },
    { text: '1 month', value: 30 },
    { text: '3 months', value: 90 },
    { text: '6 months', value: 180 },
    { text: '1 year', value: 365 }
  ];
  topMatchesOptions = [
    { text: 'All', value: 0 },
    { text: '5', value: 5 },
    { text: '10', value: 10 },
    { text: '25', value: 25 },
    { text: '50', value: 50 },
    { text: '75', value: 75 },
    { text: '100', value: 100 },
    { text: '200', value: 200 }
  ];

  clientOrBuLabel = 'Client';
  workLocations: any[] = [];
  workAuthorizationList: any[] = [];
  jobTypeList: any[] = [];
  jobTypeAdditionalList: any[] = [];
  selectedWorkLocations: any[] = [];
  selectedJobTypeList: any[] = [];
  selectedJobTypeAdditionalList: any[] = [];
  selectedWorkAuthorizationList: any[] = [];
  filterSalaryDurationOptions: any[] = [];
  filterRateDurationOptions: any[] = [];
  salaryDurationOptions: any;
  currencyCodes: any;
  selectedSort = "Please Select";
  selectedSortDir: any;
  candidateFilterItemsSelected: any[] = [];
  skeletonPlaceholders = Array(9).fill(0);

  // flags
  isLoading = true;
  savingFlag = false;
  selectAllCandidatesFlag = false;
  isAssociateCandidateForCorp = false;
  isUploadResumeOnlyEnabled = false;
  loadingJobTypeFilter = true;
  loadingAdditionalJobTypeFilter = true;
  loadingWorkAuthorizationFilter = true;
  isFilterOpen = true;
  emptyCandidateSelectedFilter = false;
  isDisplayRateFilterActive = false;
  isOutreachEnabled = false;
  noAdditionalDetails = true;
  isClearClicked = false;
  isFiltersChanged = false;
  loadingJobDetailsFlag = true;

  displayAssociateCandidateSelectedFilter: any;
  showCandidateDisplaySelectedFilterPanel = true;
  displayCandidateFilterFlag = false;
  displaySelectedFilterObj: any = {};
  deleteSelectedFilter: any = {};
  selectedCandidatesSearchText = '';

  private userId: any;
  private companyId: any;

  constructor(
    private jobService: JobService,
    private jobMatchActionsService: JobMatchActionsService,
    private candidateService: CandidateService,
    private jobMatchService: JobMatchService,
    private companyService: CompanyService,
    private genericService: GenericService,
    private modalService: AngularModalService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private requisitionService: RequisitionService,
    private authService: AuthService,
    private fourDotFiveDateFormatPipe: FourDotFiveDateFormatPipe,
    private bsModalService: BsModalService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    const userDetails = this.authService.getUserDetails();
    this.userId = userDetails.id;
    this.companyId = userDetails.company.companyId;

    this.isLoading = true;
    this.loadingJobDetailsFlag = true;
    this._initVariables();
    this.getSalaryDurationOptions();
    this.getCurrencyCodes();
    this.getJobDetails(() => {
      this.getAllWorkLocations(() => {
        this.getAllWorkAuthorizations(() => {
          this.getAllPreferredJobTypes(() => {
            this.getAllAdditionalPreferredJobTypes(() => {
              this.associateCandidatesDefaultFilter = new AssociateCandidateQueryFilter();
              this._setAllAssociatedCandidatesFilters(this.associateCandidatesDefaultFilter);
              this.associateCandidatesDefaultFilterCopy = _.cloneDeep(this.associateCandidatesDefaultFilter);
              this.matchedCandidatesContainer = new MatchedCandidatesContainer(this.userId, this.companyId, this.jobId, this.associateCandidatesDefaultFilter, this.jobDetails, this.defaultPageSize, this.jobMatchService, this.jobService, this.candidateService, this.alertsAndNotificationsService);
              this.createJobMatchesObject = {
                companyId: this.companyId,
                requisitionId: this.jobId,
                candidateIds: [],
                isAddCandidate: false,
                isAssociateCandidate: true,
                overrideNoteDetails: []
              };
              this.sortRequisitions('Score Desc', 'Score', 'Desc');
              this.isFiltersChanged = false;
              this.isLoading = false;
              this.loadingJobDetailsFlag = false;
              this.searchForMatchingCandidates();
              setTimeout(() => {
                this._createMatchScoreSlider();
              });
            });
          });
        });
      });
      this._setDisplayFilter();
      this._setResumeOptions();
      this.searchCandidates = _.debounce(this.searchCandidates.bind(this), 500);
    });
    this._checkIfOutreachEnabled();
  }

  ngAfterViewInit() {
    this._createSlimScroll();
  }

  private _setDisplayFilter() {
    this.displayAssociateCandidateSelectedFilter = new AssociateCandidateDisplayQueryFilter();
    this.showCandidateDisplaySelectedFilterPanel = this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon;
  }

  searchCandidates() {
    this.searchForMatchingCandidates();
  }

  private _initVariables() {
    this.jobDetails = undefined;
    this.associateCandidatesDefaultFilter = {};
    this.associateCandidatesDefaultFilterCopy = {};
    this.matchedCandidatesContainer = null;
    this.createJobMatchesObject = null;
    this.minimumScoreSliderPadding = 0;
    this.maximumScoreSliderPadding = 100;
    this.maximumScoreSliderTopPosition = 0;
    this.defaultPageSize = 18;
    this.clientOrBuLabel = 'Client';
    this.workLocations = [];
    this.workAuthorizationList = [];
    this.jobTypeList = [];
    this.jobTypeAdditionalList = [];
    this.selectedWorkLocations = [];
    this.selectedJobTypeList = [];
    this.selectedJobTypeAdditionalList = [];
    this.selectedWorkAuthorizationList = [];
    this.filterSalaryDurationOptions = [];
    this.filterRateDurationOptions = [];
    this.selectedSort = "Please Select";
    this.candidateFilterItemsSelected = [];
    this.savingFlag = false;
    this.selectAllCandidatesFlag = false;
    this.isAssociateCandidateForCorp = false;
    this.isUploadResumeOnlyEnabled = false;
    this.loadingJobTypeFilter = true;
    this.loadingAdditionalJobTypeFilter = true;
    this.loadingWorkAuthorizationFilter = true;
    this.isFilterOpen = false;
    this.emptyCandidateSelectedFilter = false;
    this.isDisplayRateFilterActive = false;
    this.isOutreachEnabled = false;
    this.noAdditionalDetails = true;
    this.isClearClicked = false;

    const userDetails = this.authService.getUserDetails();
    if (userDetails.company.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
      this.clientOrBuLabel = 'BU';
    }
    this.isAssociateCandidateForCorp = this.companyService.isCorporateCompany() || (this.corporateId !== undefined && this.corporateId !== "");
  }

  getJobDetails(successCallback: () => void) {
    this.jobService.getJobProfile(this.jobId, (data: any) => {
      this.jobDetails = data;
      this.jobDetails.jobSalaryDto = this.jobDetails.jobSalary;
      this._massageRequisitionCardInfo(this.jobDetails);
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllWorkLocations(successCallback: () => void) {
    this.jobService.getWorkLocations((data: any) => {
      this.workLocations = data;
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getSalaryDurationOptions() {
    this.jobService.getSalaryDurationOptions((data: any) => {
      this.salaryDurationOptions = data;
      const tempSalaryDurationOptions = _.cloneDeep(data);
      tempSalaryDurationOptions.map((duration: any) => {
        duration.name = duration.name.slice(4);
      });
      this.filterSalaryDurationOptions = tempSalaryDurationOptions.filter((salaryDuration: any) => salaryDuration.value === 'PER_YEAR');
      this.filterRateDurationOptions = tempSalaryDurationOptions.filter((salaryDuration: any) => salaryDuration.value != 'PER_YEAR');
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllPreferredJobTypes(successCallback: () => void) {
    this.loadingJobTypeFilter = true;
    this.jobService.getAllJobTypes((data: any) => {
      this.jobTypeList = data;
      this.jobTypeList.push({ name: "No Pref. Job Type", value: "NO_PREF_JOBTYPE" });
      if (successCallback) {
        successCallback();
      }
      this.loadingJobTypeFilter = false;
    }, (error: any) => {
      this.loadingJobTypeFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllAdditionalPreferredJobTypes(successCallback: () => void) {
    this.loadingAdditionalJobTypeFilter = true;
    this.jobService.getAllJobSubTypes((data: any) => {
      this.jobTypeAdditionalList = data;
      this.jobTypeAdditionalList.push({ name: 'Not Specified', value: 'NO_PREF_JOBSUBTYPE' });
      if (successCallback) {
        successCallback();
      }
      this.loadingAdditionalJobTypeFilter = false;
    }, (error: any) => {
      this.loadingAdditionalJobTypeFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllWorkAuthorizations(successCallback: () => void) {
    this.loadingWorkAuthorizationFilter = true;
    this.jobService.getAllSponsorshipTypes((data: any) => {
      this.workAuthorizationList = data;
      this.jobDetails.sponsorshipsTextList = [];
      if (this.jobDetails.sponsorships && this.jobDetails.sponsorships.length > 0) {
        this.jobDetails.sponsorshipsTextList = this.workAuthorizationList
          .filter((val: any) => this.jobDetails.sponsorships.includes(val.value))
          .map((val: any) => val.name);
      }
      if (successCallback) {
        successCallback();
      }
      this.loadingWorkAuthorizationFilter = false;
    }, (error: any) => {
      this.loadingWorkAuthorizationFilter = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getCurrencyCodes() {
    this.jobService.getCurrencyCodes((data: any) => {
      this.currencyCodes = data;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _massageRequisitionCardInfo(data: any) {
    const massagedRequisitionInfo = this.requisitionService.massageRequisitionCardInfo(data, this.salaryDurationOptions);
    _.merge(this.jobDetails, massagedRequisitionInfo.data);
  }

  private _checkIfOutreachEnabled() {
    this.isOutreachEnabled = true;
  }

  private _setAllAssociatedCandidatesFilters(associateCandidatesDefaultFilter: any) {
    if (this.jobDetails.workLocations && this.jobDetails.workLocations.length > 0) {
      this._setWorkLocations();
      associateCandidatesDefaultFilter.workLocationIds = this.jobDetails.workLocations.map((workLocation: any) => workLocation.id);
      if (this.noAdditionalDetails) {
        associateCandidatesDefaultFilter.workLocationIds.push('NO_WORK_LOCATION');
      }
    }

    if (this.jobDetails.jobType && this.jobDetails.jobType != "") {
      this._setPreferredJobType();
      associateCandidatesDefaultFilter.jobTypes.push(this.jobTypeList.filter((jobType: any) => jobType.name === this.jobDetails.jobType)[0].value);
      if (this.noAdditionalDetails) {
        associateCandidatesDefaultFilter.jobTypes.push('NO_PREF_JOBTYPE');
      }
    }

    if (this.jobDetails.sponsorships && this.jobDetails.sponsorships.length > 0) {
      this._setWorkAuthorizations();
      associateCandidatesDefaultFilter.sponsorships = this.jobDetails.sponsorships;
      if (this.noAdditionalDetails) {
        associateCandidatesDefaultFilter.sponsorships.push('NO_WORK_AUTHORIZATION_SPECIFIED');
      }
    }

    this._setSalaryOrRate(associateCandidatesDefaultFilter);
    associateCandidatesDefaultFilter.includeCandidatesWithNoAdditionalDetails = this.noAdditionalDetails;
  }

  private _setWorkLocations() {
    this.selectedWorkLocations = this.workLocations.filter((workLocation: any) => this.jobDetails.workLocations.some((value: any) => workLocation.id === value.id));
    if (this.noAdditionalDetails) {
      this.workLocations.forEach((workLocation: any) => {
        if (workLocation.name == 'No Work Location') {
          workLocation.ticked = true;
        }
      });
      const noWorkLocation = this.workLocations.filter((workLocation: any) => this.jobDetails.workLocations.some((value: any) => workLocation.name === 'No Work Location'));
      this.selectedWorkLocations = noWorkLocation ? [...this.selectedWorkLocations, ...noWorkLocation] : this.selectedWorkLocations;
    }
    this.selectedWorkLocations.forEach((work: any) => work.ticked = true);
    this._setAssociateCandidateDisplayFilters('workLocations');
  }

  private _setAssociateCandidateDisplayFilters(type: string) {
    this.isFiltersChanged = true;
    switch (type) {
      case 'workLocations':
        this.displayAssociateCandidateSelectedFilter.workLocationIds = this.selectedWorkLocations.map((val: any) => val.name);
        break;
      case 'sponsorships':
        this.displayAssociateCandidateSelectedFilter.sponsorships = this.selectedWorkAuthorizationList.map((val: any) => val.name);
        break;
      case 'jobTypes':
        this.displayAssociateCandidateSelectedFilter.jobTypes = this.selectedJobTypeList.map((val: any) => val.name);
        break;
      case 'jobSubTypes':
        this.displayAssociateCandidateSelectedFilter.jobSubTypes = this.selectedJobTypeAdditionalList.map((val: any) => val.name);
        break;
      case 'salary':
        this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        break;
      case 'rate':
        this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        this.isDisplayRateFilterActive = true;
        break;
      default:
      // Do Nothing
    }

    this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
  }

  private _setJobMatchScoreDisplayFilter(minScore: any, maxScore: any) {
    let score = "";
    if (minScore === this.jobDetails.fourDotFiveIntelligenceScore && maxScore === 100) {
      score = "";
    } else {
      score = `From ${minScore} To ${maxScore}`;
    }
    return score;
  }

  onWorkLocationSelected() {
    this.isFiltersChanged = true;
    this.matchedCandidatesContainer.searchObject.workLocationIds = this.selectedWorkLocations.map((location: any) => location.id);
    this._setAssociateCandidateDisplayFilters('workLocations');
  }

  onJobTypeSelected() {
    this.isFiltersChanged = true;
    this.matchedCandidatesContainer.searchObject.jobTypes = this.selectedJobTypeList.map((val: any) => val.value);
    this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
    this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
    this._setAssociateCandidateDisplayFilters('jobTypes');
  }

  onAdditionalJobTypeSelected() {
    this.isFiltersChanged = true;
    this.matchedCandidatesContainer.searchObject.jobSubTypes = this.selectedJobTypeAdditionalList.map((val: any) => val.value);
    this._setAssociateCandidateDisplayFilters('jobSubTypes');
  }

  onWorkAuthorizationSelected() {
    this.isFiltersChanged = true;
    this.matchedCandidatesContainer.searchObject.sponsorships = this.selectedWorkAuthorizationList.map((val: any) => val.value);
    this._setAssociateCandidateDisplayFilters('sponsorships');
  }

  onSalaryDurationChange() {
    if (this.matchedCandidatesContainer.searchObject.salaryDuration) {
      this._setAssociateCandidateDisplayFilters('salary');
    }
  }

  onRateDurationChange() {
    if (this.matchedCandidatesContainer.searchObject.rateDuration) {
      this._setAssociateCandidateDisplayFilters('rate');
    }
  }

  onSalaryOrRateCurrencyChange(type?: string) {
    this.isFiltersChanged = true;
    if (this.displayAssociateCandidateSelectedFilter.rate != "" || this.displayAssociateCandidateSelectedFilter.salary != "") {
      this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
      this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
    } else if (type === 'salary') {
      this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
    } else {
      this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
    }

    this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    this.isDisplayRateFilterActive = this.matchedCandidatesContainer.searchObject.rate && this.matchedCandidatesContainer.searchObject.rate != "" ? true : false;
  }

  private _setWorkAuthorizations() {
    this.selectedWorkAuthorizationList = this.workAuthorizationList.filter((work: any) => this.jobDetails.sponsorships.some((value: any) => work.value === value));
    if (this.noAdditionalDetails) {
      this.workAuthorizationList.forEach((workAuth: any) => {
        if (workAuth.name == 'No Work Authorization') {
          workAuth.ticked = true;
        }
      });
      const noWorkAuthorization = this.workAuthorizationList.filter((work: any) => this.jobDetails.sponsorships.some((value: any) => work.name === 'No Work Authorization'));
      this.selectedWorkAuthorizationList = noWorkAuthorization ? [...this.selectedWorkAuthorizationList, ...noWorkAuthorization] : this.selectedWorkAuthorizationList;
    }
    this.selectedWorkAuthorizationList.forEach((work: any) => work.ticked = true);
    this._setAssociateCandidateDisplayFilters('sponsorships');
  }

  private _setPreferredJobType() {
    this.selectedJobTypeList = this.jobTypeList.filter((jobType: any) => jobType.name === this.jobDetails.jobType);
    if (this.noAdditionalDetails) {
      this.jobTypeList.forEach((jobType: any) => {
        if (jobType.name == 'No Pref. Job Type') {
          jobType.ticked = true;
        }
      });
      const noPreferredJobType = this.jobTypeList.filter((jobType: any) => jobType.name === 'No Pref. Job Type');
      this.selectedJobTypeList = noPreferredJobType ? [...this.selectedJobTypeList, ...noPreferredJobType] : this.selectedJobTypeList;
    }
    this.selectedJobTypeList.forEach((jobType: any) => jobType.ticked = true);
    this._setAssociateCandidateDisplayFilters('jobTypes');
  }

  private _setSalaryAndRateDisplayFilter(type: string) {
    let salaryOrRateFilter = "";
    if (type === 'salary') {
      salaryOrRateFilter = this.matchedCandidatesContainer.searchObject.salary ?
        `${this.matchedCandidatesContainer.searchObject.salary.toString() + " " + this.matchedCandidatesContainer.searchObject.salaryCurrency + " " + this._setDisplayFilterSalaryOrRateDuration('salary') + this._setSalaryOrRateNotSpecified('salary')}` : "";
    } else {
      salaryOrRateFilter = this.matchedCandidatesContainer.searchObject.rate ?
        `${this.matchedCandidatesContainer.searchObject.rate.toString() + " " + this.matchedCandidatesContainer.searchObject.rateCurrency + " " + this._setDisplayFilterSalaryOrRateDuration('rate') + this._setSalaryOrRateNotSpecified('rate')}` : "";
    }
    return salaryOrRateFilter;
  }

  private _setDisplayFilterSalaryOrRateDuration(type: string) {
    let durationOption = "";
    if (!this.salaryDurationOptions) {
      return durationOption;
    }
    if (type === 'salary') {
      const match = this.salaryDurationOptions.find((val: any) => this.matchedCandidatesContainer.searchObject.salaryDuration === val.value);
      durationOption = match ? match.name : "";
    } else {
      const match = this.salaryDurationOptions.find((val: any) => this.matchedCandidatesContainer.searchObject.rateDuration === val.value);
      durationOption = match ? match.name : "";
    }
    return durationOption;
  }

  addToDisplayFilters(event: string) {
    switch (event) {
      case 'search':
        this.displayAssociateCandidateSelectedFilter.searchText = this.matchedCandidatesContainer.searchObject.searchText;
        break;
      default:
        break;
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
  }

  private _setSalaryOrRate(filter: any) {
    if (this.jobDetails.jobSalary) {
      filter.currency = this.jobDetails.jobSalary.currency;
      if (this.jobDetails.jobSalary.salaryDuration === 'PER_YEAR') {
        filter.salaryDuration = this.jobDetails.jobSalary.salaryDuration;
        filter.salary = this.jobDetails.jobSalary.maxSalary;
        const salaryDurationMatch = this.salaryDurationOptions && this.salaryDurationOptions.find((val: any) => filter.salaryDuration === val.value);
        this.displayAssociateCandidateSelectedFilter.salary = filter.salary && salaryDurationMatch ? `${filter.salary.toString() + " " + filter.currency + " " + salaryDurationMatch.name}` : "";
      } else {
        filter.rateDuration = this.jobDetails.jobSalary.salaryDuration;
        filter.rate = this.jobDetails.jobSalary.maxSalary;
        const rateDurationMatch = this.salaryDurationOptions && this.salaryDurationOptions.find((val: any) => filter.rateDuration === val.value);
        this.displayAssociateCandidateSelectedFilter.rate = filter.rate && rateDurationMatch ? `${filter.rate.toString() + " " + filter.currency + " " + rateDurationMatch.name}` : "";
      }

      if (this.associateCandidatesDefaultFilter.includeCandidatesWithNoAdditionalDetails) {
        if (filter.salary) {
          this.displayAssociateCandidateSelectedFilter.salary = this.displayAssociateCandidateSelectedFilter.salary + " OR Salary = Not Specified";
        }
        if (filter.rate) {
          this.displayAssociateCandidateSelectedFilter.rate = this.displayAssociateCandidateSelectedFilter.rate + " OR Rate = Not Specified";
        }
      }
    }

    this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
  }

  checkPreferredJobType(jobType: string) {
    let isJobTypePresent;
    if (this.selectedJobTypeList && this.selectedJobTypeList.length > 0) {
      for (let i = 0; i < this.selectedJobTypeList.length; i++) {
        if (this.selectedJobTypeList[i].value === jobType) {
          isJobTypePresent = true;
          break;
        } else {
          isJobTypePresent = false;
        }
      }
    } else {
      isJobTypePresent = false;
    }
    return isJobTypePresent;
  }

  sortRequisitions(sortColumn: string, selectedSort: string, selectedSortDir: string) {
    this.isFiltersChanged = true;
    this.selectedSort = selectedSort;
    this.selectedSortDir = selectedSortDir;
    this.matchedCandidatesContainer.searchObject.column = "";
    this.matchedCandidatesContainer.searchObject.sortDirection = "";
    if (sortColumn !== undefined && sortColumn != "") {
      const array = sortColumn.split(" ");
      this.matchedCandidatesContainer.searchObject.column = array[0];
      this.matchedCandidatesContainer.searchObject.sortDirection = array[1];
    }

    this.displayAssociateCandidateSelectedFilter.selectedFilterSort = "";
    if (this.selectedSort != 'Please Select') {
      this.displayAssociateCandidateSelectedFilter.selectedFilterSort = this.selectedSort + " " + "(" + this.selectedSortDir + ")";
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
  }

  selectRemoveAll(label: string, type: string) {
    if (type == 'selectAll') {
      switch (label) {
        case 'workLocations':
          this.selectedWorkLocations = [...this.workLocations];
          this.onWorkLocationSelected();
          break;
        case 'jobType':
          this.selectedJobTypeList = [...this.jobTypeList];
          this.onJobTypeSelected();
          break;
        case 'jobSubTypes':
          this.selectedJobTypeAdditionalList = [...this.jobTypeAdditionalList];
          this.onAdditionalJobTypeSelected();
          break;
        case 'sponsorships':
          this.selectedWorkAuthorizationList = [...this.workAuthorizationList];
          this.onWorkAuthorizationSelected();
          break;
        default:
        // do nothing;
      }
    } else {
      switch (label) {
        case 'workLocations':
          this.selectedWorkLocations = [];
          this.onWorkLocationSelected();
          break;
        case 'jobType':
          this.selectedJobTypeList = [];
          this.onJobTypeSelected();
          break;
        case 'jobSubTypes':
          this.selectedJobTypeAdditionalList = [];
          this.onAdditionalJobTypeSelected();
          break;
        case 'sponsorships':
          this.selectedWorkAuthorizationList = [];
          this.onWorkAuthorizationSelected();
          break;
        default:
        // do nothing
      }
    }
  }

  resetAssociateCandidatesFilters(type: string) {
    this.isFiltersChanged = true;
    this.isClearClicked = type === 'reset' ? false : true;
    if (this.matchedCandidatesContainer.searchByTextFlag) {
      this.matchedCandidatesContainer.searchObject.searchText = "";
      this.displayAssociateCandidateSelectedFilter.searchText = '';
      this.matchedCandidatesContainer.searchObject.requestSource = 'CONTACT';
      this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
      this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = type === 'reset' ? true : false;
    } else if (!this.matchedCandidatesContainer.searchByTextFlag) {
      this.matchedCandidatesContainer.searchObject.numberOfDays = 0;
      this.matchedCandidatesContainer.topMatches = 0;
      this.matchedCandidatesContainer.searchObject.topMatches = this.matchedCandidatesContainer.topMatches;
      this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
      this.displayAssociateCandidateSelectedFilter.topMatches = '';
      this.displayAssociateCandidateSelectedFilter.score = '';
      this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
      this.matchedCandidatesContainer.searchObject.requestSource = 'JOB_MATCH_SCORE';
      this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = false;
    }

    this.displayAssociateCandidateSelectedFilter.workLocationIds = [];
    if (this.associateCandidatesDefaultFilterCopy.workLocationIds && this.associateCandidatesDefaultFilterCopy.workLocationIds.length > 0 && type === 'reset') {
      this.workLocations.forEach((workLocation: any) => {
        if (this.associateCandidatesDefaultFilterCopy.workLocationIds.includes(workLocation.id)) {
          workLocation.ticked = true;
          this.displayAssociateCandidateSelectedFilter.workLocationIds.push(workLocation.name);
        } else {
          workLocation.ticked = false;
        }
      });
      this.selectedWorkLocations = this.workLocations.filter((workLocation: any) => workLocation.ticked);
    } else {
      this.workLocations.forEach((workLocation: any) => workLocation.ticked = false);
      this.selectedWorkLocations = [];
    }
    this.matchedCandidatesContainer.searchObject.workLocationIds = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.workLocationIds : [];

    this.displayAssociateCandidateSelectedFilter.sponsorships = [];
    if (this.associateCandidatesDefaultFilterCopy.sponsorships && this.associateCandidatesDefaultFilterCopy.sponsorships.length && type === 'reset') {
      this.workAuthorizationList.forEach((work: any) => {
        if (this.associateCandidatesDefaultFilterCopy.sponsorships.includes(work.value)) {
          this.displayAssociateCandidateSelectedFilter.sponsorships.push(work.name);
          work.ticked = true;
        } else {
          work.ticked = false;
        }
      });
      this.selectedWorkAuthorizationList = this.workAuthorizationList.filter((work: any) => work.ticked);
    } else {
      this.workAuthorizationList.forEach((work: any) => work.ticked = false);
      this.selectedWorkAuthorizationList = [];
    }
    this.matchedCandidatesContainer.searchObject.sponsorships = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.sponsorships : [];

    this.displayAssociateCandidateSelectedFilter.jobTypes = [];
    if (this.associateCandidatesDefaultFilterCopy.jobTypes && this.associateCandidatesDefaultFilterCopy.jobTypes.length > 0 && type === 'reset') {
      this.jobTypeList.forEach((jobType: any) => {
        if (this.associateCandidatesDefaultFilterCopy.jobTypes.includes(jobType.value)) {
          this.displayAssociateCandidateSelectedFilter.jobTypes.push(jobType.name);
          jobType.ticked = true;
        } else {
          jobType.ticked = false;
        }
      });
      this.selectedJobTypeList = this.jobTypeList.filter((jobType: any) => jobType.ticked);
    } else {
      this.jobTypeList.forEach((jobType: any) => jobType.ticked = false);
      this.selectedJobTypeList = [];
    }
    this.matchedCandidatesContainer.searchObject.jobTypes = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.jobTypes : [];

    this.displayAssociateCandidateSelectedFilter.jobSubTypes = [];
    if (this.associateCandidatesDefaultFilterCopy.jobSubTypes && this.associateCandidatesDefaultFilterCopy.jobSubTypes.length > 0 && type === 'reset') {
      this.jobTypeAdditionalList.forEach((jobSubType: any) => {
        if (this.associateCandidatesDefaultFilterCopy.jobSubType.includes(jobSubType.value)) {
          this.displayAssociateCandidateSelectedFilter.jobSubTypes.push(jobSubType.name);
          jobSubType.ticked = true;
        } else {
          jobSubType.ticked = false;
        }
      });
      this.selectedJobTypeAdditionalList = this.jobTypeAdditionalList.filter((jobSubType: any) => jobSubType.ticked);
    } else {
      this.jobTypeAdditionalList.forEach((jobSubType: any) => jobSubType.ticked = false);
      this.selectedJobTypeAdditionalList = [];
    }
    this.matchedCandidatesContainer.searchObject.jobSubTypes = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.jobSubTypes : [];
    this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.includeCandidatesWithNoAdditionalDetails : false;

    this.matchedCandidatesContainer.searchObject.salary = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.salary : null;
    this.matchedCandidatesContainer.searchObject.rate = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.rate : null;
    this.matchedCandidatesContainer.searchObject.salaryDuration = this.associateCandidatesDefaultFilterCopy.salaryDuration;
    this.matchedCandidatesContainer.searchObject.rateDuration = this.associateCandidatesDefaultFilterCopy.rateDuration;
    this.matchedCandidatesContainer.searchObject.salaryCurrency = this.associateCandidatesDefaultFilterCopy.salaryCurrency;
    this.matchedCandidatesContainer.searchObject.rateCurrency = this.associateCandidatesDefaultFilterCopy.rateCurrency;
    this.displayAssociateCandidateSelectedFilter.salary = type === 'reset' ? this._setSalaryAndRateDisplayFilter('salary') : "";
    this.displayAssociateCandidateSelectedFilter.rate = type === 'reset' ? this._setSalaryAndRateDisplayFilter('rate') : "";

    this.matchedCandidatesContainer.searchObject.minimumScore = this.jobDetails.fourDotFiveIntelligenceScore;
    this.matchedCandidatesContainer.searchObject.maximumScore = 100;
    this._createMatchScoreSlider();

    if (type === 'clear') {
      this.sortRequisitions('', 'Please Select', '');
      this.matchedCandidatesContainer.searchObject.column = "Score";
      this.matchedCandidatesContainer.searchObject.sortDirection = "Desc";
    } else {
      this.sortRequisitions('Score Desc', 'Score', 'Desc');
      this.matchedCandidatesContainer.searchObject.column = "Score";
      this.matchedCandidatesContainer.searchObject.sortDirection = "Desc";
    }
    this.isDisplayRateFilterActive = this.matchedCandidatesContainer.searchObject.rate && this.matchedCandidatesContainer.searchObject.rate != "" ? true : false;
  }

  onGlobalFilterChange(event?: any) {
    this._setOpenGlobalFilter();
  }

  toggleGlobalFilterPanel() {
    this.isFiltersChanged = true;
    $("#associate-search-panel").animate({
      height: 'toggle'
    });
    this.isFilterOpen = !this.isFilterOpen;
  }

  displaySelectedFilterToggle() {
    this.showCandidateDisplaySelectedFilterPanel = true;
    if (this.displayCandidateFilterFlag) {
      $("#display-Associate-candidate-selected-filter-panel").animate({
        height: 'toggle'
      });
      this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon = !this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon;
    }
    this._setShowCandidateDisplayFilterIcon(this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon);
  }

  private _setObjectVariableName(currentObject: any) {
    const selectedFilterVariableNameObj: any = {
      searchText: "Search", numberOfDays: "Last Modified", topMatches: "Top Matches", workLocationIds: "Work Locations",
      jobTypes: "Job Type", jobSubTypes: "Additional Contract Types", sponsorships: "Work Authorizations", salary: "Salary",
      rate: "Rate", selectedFilterSort: "Sort By", score: "Job Match Score"
    };

    for (const key in selectedFilterVariableNameObj) {
      if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
        const obj = selectedFilterVariableNameObj[key];
        if (key == currentObject.variable) {
          this.displaySelectedFilterObj.variable = obj;
        }
      }
    }
  }

  setCandidateDisplayedFilterItemSelected(itemsSelected: any) {
    this.emptyCandidateSelectedFilter = false;
    for (const key in itemsSelected) {
      if (itemsSelected.hasOwnProperty(key)) {
        const obj = itemsSelected[key];
        if (obj.length > 0) {
          this.displayCandidateFilterFlag = true;
          this.displaySelectedFilterObj = {};

          if (this.candidateFilterItemsSelected.length !== 0) {
            this.candidateFilterItemsSelected.forEach((filterItem: any) => {
              if (filterItem.filter == key) {
                if (filterItem.setSelectedFilterLimit == 5) {
                  this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                } else {
                  this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                }
              }
            });
          }

          if (this.candidateFilterItemsSelected.length == 0 || Object.keys(this.displaySelectedFilterObj).length == 0) {
            this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
          }

          this._setObjectVariableName(this.displaySelectedFilterObj);

          if (this.candidateFilterItemsSelected.length > 0) {
            this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter((item: any) => item.variable !== this.displaySelectedFilterObj.variable);
          }
          this.candidateFilterItemsSelected.push(this.displaySelectedFilterObj);
        } else {
          if (this.candidateFilterItemsSelected.length > 0) {
            this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter((item: any) => item.filter !== key);
          }
        }
      }
    }

    if (this.candidateFilterItemsSelected.length === 0) {
      if (!this.matchedCandidatesContainer.isFilterOn) {
        this.displayCandidateFilterFlag = false;
        this._setShowCandidateDisplayFilterIcon(true);
      } else {
        this.emptyCandidateSelectedFilter = true;
      }
    }
  }

  private _setShowCandidateDisplayFilterIcon(bool: boolean) {
    if (this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon !== bool) {
      this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon = bool;
    }
  }

  isFilterValueArray(value: any) {
    return Array.isArray(value);
  }

  getMultiSelectSummary(items: any[], bindLabel: string): string {
    if (!items || items.length === 0) { return ''; }
    const firstLabel = items[0][bindLabel];
    return items.length > 1 ? `${firstLabel} ... (${items.length})` : firstLabel;
  }

  private _deleteSelectedItem(currentObject: any, deletedItem: any) {
    switch (currentObject.variable) {
      case 'searchText':
        this.matchedCandidatesContainer.searchObject.searchText = '';
        this.displayAssociateCandidateSelectedFilter.searchText = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
        break;
      case 'score':
        this.matchedCandidatesContainer.searchObject.minimumScore = this.jobDetails.fourDotFiveIntelligenceScore;
        this.matchedCandidatesContainer.searchObject.maximumScore = 100;
        this._createMatchScoreSlider();
        this.displayAssociateCandidateSelectedFilter.score = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
        break;
      case 'numberOfDays':
        this.matchedCandidatesContainer.searchObject.numberOfDays = 0;
        this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
        break;
      case 'topMatches':
        this.matchedCandidatesContainer.searchObject.topMatches = 0;
        this.matchedCandidatesContainer.topMatches = 0;
        this.displayAssociateCandidateSelectedFilter.topMatches = '';
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
        break;
      case 'workLocationIds':
        this.workLocations.forEach((workLocation: any) => {
          if (workLocation.name === deletedItem) {
            workLocation.ticked = false;
            this.selectedWorkLocations = this.selectedWorkLocations.filter((item: any) => item.name !== deletedItem);
          }
        });
        this.onWorkLocationSelected();
        break;
      case 'jobTypes':
        this.jobTypeList.forEach((jobType: any) => {
          if (jobType.name === deletedItem) {
            jobType.ticked = false;
            this.selectedJobTypeList = this.selectedJobTypeList.filter((item: any) => item.name !== deletedItem);
          }
        });
        this.onJobTypeSelected();
        break;
      case 'jobSubTypes':
        this.jobTypeAdditionalList.forEach((additionalJobType: any) => {
          if (additionalJobType.name === deletedItem) {
            additionalJobType.ticked = false;
            this.selectedJobTypeAdditionalList = this.selectedJobTypeAdditionalList.filter((item: any) => item.name !== deletedItem);
          }
        });
        this.onAdditionalJobTypeSelected();
        break;
      case 'sponsorships':
        this.workAuthorizationList.forEach((sponsorship: any) => {
          if (sponsorship.value === deletedItem) {
            sponsorship.ticked = false;
            this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter((item: any) => item.value !== deletedItem);
          } else if (sponsorship.name === deletedItem) {
            sponsorship.ticked = false;
            this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter((item: any) => item.name !== deletedItem);
          }
        });
        this.onWorkAuthorizationSelected();
        break;
      case 'salary':
        this.matchedCandidatesContainer.searchObject.salary = null;
        this.displayAssociateCandidateSelectedFilter.salary = "";
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
        break;
      case 'rate':
        this.matchedCandidatesContainer.searchObject.rate = null;
        this.displayAssociateCandidateSelectedFilter.rate = "";
        this.isDisplayRateFilterActive = false;
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
        break;
      case 'selectedFilterSort':
        this.sortRequisitions('', 'Please Select', '');
        break;
      default:
        break;
    }
  }

  deleteSelectedFilterItem(deletedItem: any) {
    for (const key in this.displayAssociateCandidateSelectedFilter) {
      if (this.displayAssociateCandidateSelectedFilter.hasOwnProperty(key)) {
        const obj = this.displayAssociateCandidateSelectedFilter[key];
        if (Array.isArray(obj)) {
          if (obj.includes(deletedItem)) {
            this.deleteSelectedFilter = {};
            this.deleteSelectedFilter = { variable: key, value: obj };
            this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
          }
        } else {
          if (obj == deletedItem) {
            this.deleteSelectedFilter = {};
            this.deleteSelectedFilter = { variable: key, value: obj };
            this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
          }
        }
      }
    }
  }

  private _setOpenGlobalFilter() {
    this.isFiltersChanged = true;
    if (!this.isFilterOpen) {
      $("#associate-search-panel").animate({
        height: 'toggle'
      });
      this.isFilterOpen = true;
    }
  }

  private _setResumeOptions() {
    let companyIdToCheckAUploadResumeAccess;
    if (this.isAssociateCandidateForCorp) {
      this.clientOrBuId = null;
    }
    if (this.corporateId !== undefined && this.corporateId !== "") {
      companyIdToCheckAUploadResumeAccess = this.corporateId;
    } else {
      companyIdToCheckAUploadResumeAccess = this.companyId;
    }

    if ((this.isSharedRequisition && this.corporateId !== undefined && this.corporateId !== "") || (!this.isAssociateCandidateForCorp)) {
      this.companyService.hasAccessToUploadResume(companyIdToCheckAUploadResumeAccess, this.clientOrBuId, (data: any) => {
        this.isUploadResumeOnlyEnabled = data;
      }, (error: any) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else {
      this.isUploadResumeOnlyEnabled = false;
    }
  }

  checkIfSalaryOrRateDefined(type: string) {
    const isNoPrefJobTypeSelected = this.selectedJobTypeList.some((item: any) => item && item.value === 'NO_PREF_JOBTYPE');
    if (type === 'salary') {
      if (this.matchedCandidatesContainer.searchObject.salary === undefined || this.matchedCandidatesContainer.searchObject.salary < 0) {
        this.matchedCandidatesContainer.searchObject.salary = 1;
      }
      this._setAssociateCandidateDisplayFilters('salary');
      if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails ||
        (!this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails && isNoPrefJobTypeSelected)) {
        this._setAssociateCandidateDisplayFilters('rate');
      }
    } else if (type === 'rate') {
      if (this.matchedCandidatesContainer.searchObject.rate === undefined || this.matchedCandidatesContainer.searchObject.rate < 0) {
        this.matchedCandidatesContainer.searchObject.rate = 1;
      }
      this._setAssociateCandidateDisplayFilters('rate');
      if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails ||
        (!this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails && isNoPrefJobTypeSelected)) {
        this._setAssociateCandidateDisplayFilters('salary');
      }
    }
  }

  private _checkIfCandidatesInformationMatch(candidate: any) {
    let candidateInformationMatch = false;
    if (candidate.candidateAdditionalDetailsCard &&
      (this.associateCandidatesDefaultFilterCopy.jobTypes.length === 0 || candidate.candidateAdditionalDetailsCard.preferredJobIcon === 'GREEN') &&
      ((!this.associateCandidatesDefaultFilterCopy.salary && !this.associateCandidatesDefaultFilterCopy.rate) || candidate.candidateAdditionalDetailsCard.salaryIcon === 'GREEN') &&
      (this.associateCandidatesDefaultFilterCopy.sponsorships.length === 0 || candidate.candidateAdditionalDetailsCard.sponsorshipIcon === 'GREEN') &&
      (this.associateCandidatesDefaultFilterCopy.workLocationIds.length === 0 || (candidate.workLocationsMatchStatus && candidate.workLocationsMatchStatus === 'match'))
    ) {
      candidateInformationMatch = true;
    }
    return candidateInformationMatch;
  }

  private _setMessageCandidateInformation(candidate: any) {
    const messageOptions: string[] = [];
    if (candidate.candidateAdditionalDetailsCard) {
      if (this.associateCandidatesDefaultFilterCopy.jobTypes.length > 0 && candidate.candidateAdditionalDetailsCard.preferredJobIcon != 'GREEN') {
        messageOptions.push("Preferred job types");
      }
      if ((this.associateCandidatesDefaultFilterCopy.salary || this.associateCandidatesDefaultFilterCopy.rate) && candidate.candidateAdditionalDetailsCard.salaryIcon != 'GREEN') {
        messageOptions.push("Salary");
      }
      if (this.associateCandidatesDefaultFilterCopy.sponsorships.length > 0 && candidate.candidateAdditionalDetailsCard.sponsorshipIcon != 'GREEN') {
        messageOptions.push("Sponsorships");
      }
      if (this.associateCandidatesDefaultFilterCopy.workLocationIds.length > 0 && (!candidate.workLocationsMatchStatus || candidate.workLocationsMatchStatus != 'match')) {
        messageOptions.push("Work locations");
      }
    }

    if (messageOptions.length > 0) {
      return messageOptions.toString().split(',').join(', ');
    } else {
      return "";
    }
  }

  addToSelectedCandidates(candidate: any) {
    if (!this._checkIfCandidatesInformationMatch(candidate) || (this.resumeRequiredForWorkflow && !candidate.resumeExist)) {
      const title = "Alert";
      const candidateName = candidate.name ? `<span class="font-bold">${candidate.name}</span>` : "Candidate's";
      let message = '';
      if (this._checkIfCandidatesInformationMatch(candidate) && (this.resumeRequiredForWorkflow && !candidate.resumeExist)) {
        message = `<div>
                    ${this.setIsResumeRequiredForWorkflowMessage(candidate)}
                    <p class="mb-0">Add it Anyway?</p>
                </div>`;
      } else if (!this._checkIfCandidatesInformationMatch(candidate) && (this.resumeRequiredForWorkflow && !candidate.resumeExist)) {
        message = `<div>
                    ${this.setIsResumeRequiredForWorkflowMessage(candidate)}
                    <p>${candidateName} '<span class="text-primary">${this._setMessageCandidateInformation(candidate)}</span>' entry does not match with the Requisition.</p>
                    <p class="mb-0">Add it Anyway?</p>
                </div>`;
      } else {
        message = `<div>
                    <p>${candidateName} '<span class="text-primary">${this._setMessageCandidateInformation(candidate)}</span>' entry does not match with the Requisition.</p>
                    <p class="mb-0">Add it Anyway?</p>
                </div>`;
      }
      this.alertsAndNotificationsService.showConfirm(title, message, "warning", false, () => {
        this.selectCandidate(candidate);
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      }, () => {
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    } else {
      this.selectCandidate(candidate);
    }
  }

  selectCandidate(candidate: any) {
    if (candidate.showOverride) {
      this.matchedCandidatesContainer.selectedCandidates.push(candidate);
      this._confirmOverrideSuspension(candidate);
    } else if (candidate.allowManualMatch) {
      candidate.selectedFlag = true;
      this.matchedCandidatesContainer.selectedCandidates.push(candidate);
    } else {
      this._showBootboxWarning(candidate.reasonForNoManualMatch);
    }
  }

  private _confirmOverrideSuspension(candidate: any) {
    const message = candidate.reasonForNoManualMatch;
    const allowOverride = candidate.allowOverride;
    let suspendedMonths = 0;
    let releaseDate: any = '';
    let releasedJobDetails: any = {};
    let type = "release";
    const candidateId = candidate.id;
    const candidateName = candidate.name;

    if (candidate.overrideFor == "JOB_LEFT") {
      suspendedMonths = candidate.jobLeftDetail.numberOfMonthsToWait;
      releaseDate = this.fourDotFiveDateFormatPipe.transform(candidate.jobLeftDetail.leftAt);
      releasedJobDetails = candidate.jobLeftDetail;
      type = "jobLeft";
    } else {
      suspendedMonths = candidate.releasedCandidateDetail.numberOfMonthsToWait;
      releaseDate = this.fourDotFiveDateFormatPipe.transform(candidate.releasedCandidateDetail.releasedAt);
      releasedJobDetails = candidate.releasedCandidateDetail;
    }

    if (allowOverride) {
      const vm = this;
      this.alertsAndNotificationsService.showCustomConfirm('Override', 'Cancel', 'Confirm', message, 'warning', 'medium', () => {
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("associate-candidate-modal");
        setTimeout(() => {
          let bsModalRef: BsModalRef;
          const config = new ModalConfig();
          config.class = 'four-dot-five-modal-medium';
          config.initialState = {
            candidateId,
            candidateName,
            suspendedMonths,
            releaseDate,
            allowOverride,
            releasedJobDetails,
            type,
            saveCallback: (recruiterDetails: any) => {
              if (type === "release") {
                candidate.releasedCandidateDetail.releasedAt = null;
              } else {
                candidate.jobLeftDetail.leftAt = null;
              }
              vm.createJobMatchesObject.overrideNoteDetails.push(recruiterDetails);
            },
            cancelCallback: () => {
              vm.removeCandidate(candidate);
            }
          };
          bsModalRef = this.bsModalService.show(AssociateCandidatesActionsModalComponent, config);
          this.warningModal = bsModalRef;
        }, 300);
      }, () => {
        vm.removeCandidate(candidate);
        vm.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    } else {
      let displayHtmlText = "";
      if (type == 'release') {
        displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
        displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.fourDotFiveDateFormatPipe.transform(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
      } else {
        displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
        displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.fourDotFiveDateFormatPipe.transform(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
      }

      this.alertsAndNotificationsService.showAlertWithCallBack("Cannot add candidate", displayHtmlText, "warning", () => {
        this.removeCandidate(candidate);
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    }
  }

  private _showBootboxWarning(message: any) {
    this.alertsAndNotificationsService.showAlertWithCallBack("Cannot associate candidate", message, "warning", () => {
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    });
  }

  removeCandidate(candidate: any) {
    this.matchedCandidatesContainer.selectedCandidates = this.matchedCandidatesContainer.selectedCandidates.filter((c: any) => c.id !== candidate.id);
    if (this.createJobMatchesObject.overrideNoteDetail) {
      this.createJobMatchesObject.overrideNoteDetail = this.createJobMatchesObject.overrideNoteDetail.filter((note: any) => note.candidateId !== candidate.id);
    }
    const index = this.matchedCandidatesContainer.candidates.findIndex((c: any) => c.id === candidate.id);
    if (index >= 0) {
      this.matchedCandidatesContainer.candidates[index].selectedFlag = false;
    }
    this.matchedCandidatesContainer.selectAllDoneFlag = false;
  }

  private _createSlimScroll() {
    setTimeout(() => {
      if ($ && $.fn && $.fn.slimScroll) {
        // Matched-candidates div is left on native scroll (see CSS overflow-y: scroll) -
        // slimScroll replaces native scroll events with its own drag/wheel handling,
        // which stops the infiniteScroll directive's (scrolled) event from firing.
        $('.associate-candidates-selected-candidates-div').slimScroll({
          start: 'top', alwaysVisible: false, railVisible: false, wheelStep: 20, allowPageScroll: true, height: '380px'
        });
      }
    }, 100);
  }

  selectAllCandidates() {
    this.matchedCandidatesContainer.selectAllDoneFlag = true;
    const tempSearchObject = _.cloneDeep(this.matchedCandidatesContainer.searchObject);
    if (this.matchedCandidatesContainer.searchByTextFlag) {
      delete tempSearchObject.minimumScore;
      delete tempSearchObject.maximumScore;
    } else {
      delete tempSearchObject.searchText;
    }
    if (tempSearchObject.numberOfDays == 0) {
      delete tempSearchObject.numberOfDays;
    }
    tempSearchObject.page = 1;
    tempSearchObject.size = this.matchedCandidatesContainer.totalCandidateCount;
    const selectingAllCandidatesDialog = this.alertsAndNotificationsService.showLoadingDialog('Selecting ' + this.matchedCandidatesContainer.totalCandidateCount + ' Candidates');
    tempSearchObject.loggedInUserId = this.userId;
    this.jobService.findMatchingCandidatesForJob(tempSearchObject, (data: any) => {
      selectingAllCandidatesDialog.modal('hide');
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      data.candidateMinimumInfoDtos.forEach((val: any) => {
        const basicCandidateInfo = this._getBasicCandidateInfo(val);
        const indexInSelectedCandidates = this.matchedCandidatesContainer.selectedCandidates.findIndex((c: any) => c.id === basicCandidateInfo.id);
        if (indexInSelectedCandidates < 0) {
          this.selectCandidate(basicCandidateInfo);
        }
        const indexInVisibleCandidates = this.matchedCandidatesContainer.candidates.findIndex((c: any) => c.id === basicCandidateInfo.id);
        if (indexInVisibleCandidates >= 0) {
          this.matchedCandidatesContainer.candidates[indexInVisibleCandidates].selectedFlag = true;
        }
      });
    }, (error: any) => {
      selectingAllCandidatesDialog.modal('hide');
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  deselectAllCandidates() {
    this.matchedCandidatesContainer.selectAllDoneFlag = false;
    const tempSearchObject = _.cloneDeep(this.matchedCandidatesContainer.searchObject);
    if (this.matchedCandidatesContainer.searchByTextFlag) {
      delete tempSearchObject.minimumScore;
      delete tempSearchObject.maximumScore;
    } else {
      delete tempSearchObject.searchText;
    }
    if (tempSearchObject.numberOfDays == 0) {
      delete tempSearchObject.numberOfDays;
    }
    tempSearchObject.page = 1;
    tempSearchObject.size = this.matchedCandidatesContainer.totalCandidateCount;
    const selectingAllCandidatesDialog = this.alertsAndNotificationsService.showLoadingDialog('Deselecting ' + this.matchedCandidatesContainer.totalCandidateCount + ' Candidates');
    tempSearchObject.loggedInUserId = this.userId;
    this.jobService.findMatchingCandidatesForJob(tempSearchObject, (data: any) => {
      selectingAllCandidatesDialog.modal('hide');
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      data.candidateMinimumInfoDtos.forEach((val: any) => {
        const basicCandidateInfo = this._getBasicCandidateInfo(val);
        const indexInSelectedCandidates = this.matchedCandidatesContainer.selectedCandidates.findIndex((c: any) => c.id === basicCandidateInfo.id);
        if (indexInSelectedCandidates >= 0) {
          this.removeCandidate(basicCandidateInfo);
        }
      });
    }, (error: any) => {
      selectingAllCandidatesDialog.modal('hide');
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  deselectAllSelectedCandidates() {
    this.matchedCandidatesContainer.selectedCandidates.forEach((val: any) => {
      const index = this.matchedCandidatesContainer.candidates.findIndex((c: any) => c.id === val.id);
      if (index >= 0) {
        this.matchedCandidatesContainer.candidates[index].selectedFlag = false;
      }
    });
    this.matchedCandidatesContainer.selectAllDoneFlag = false;
    this.matchedCandidatesContainer.selectedCandidates = [];
  }

  onTopMatchFilterMatchesFilterChange() {
    this.matchedCandidatesContainer.searchObject.topMatches = this.matchedCandidatesContainer.topMatches;
    if (this.matchedCandidatesContainer.searchObject.topMatches == 0) {
      this.displayAssociateCandidateSelectedFilter.topMatches = '';
    } else {
      this.displayAssociateCandidateSelectedFilter.topMatches = this.topMatchesOptions.filter((topMatch: any) => topMatch.value == this.matchedCandidatesContainer.searchObject.topMatches)[0].text;
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
  }

  onLastModifiedFilterChange() {
    if (this.matchedCandidatesContainer.searchObject.numberOfDays == 0) {
      this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
    } else {
      this.displayAssociateCandidateSelectedFilter.numberOfDays = this.lastModifiedOptions.filter((lastModified: any) => lastModified.value == this.matchedCandidatesContainer.searchObject.numberOfDays)[0].text;
    }
    this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
  }

  searchTypeChanged() {
    if (!this.matchedCandidatesContainer.searchByTextFlag) {
      this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = false;
      this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
      this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails = this.isClearClicked ? false : true;
      this.matchedCandidatesContainer.searchObject.requestSource = 'JOB_MATCH_SCORE';
      this.matchedCandidatesContainer.searchObject.numberOfDays = 0;
      this.matchedCandidatesContainer.topMatches = 0;
      this.matchedCandidatesContainer.searchObject.topMatches = this.matchedCandidatesContainer.topMatches;
      this.displayAssociateCandidateSelectedFilter.searchText = '';
      this.displayAssociateCandidateSelectedFilter.score = this._setJobMatchScoreDisplayFilter(this.matchedCandidatesContainer.searchObject.minimumScore, this.matchedCandidatesContainer.searchObject.maximumScore);
      this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
      this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
      this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
      this.sortRequisitions('Score Desc', 'Score', 'Desc');
      setTimeout(() => this._restoreMatchScoreSlider());
    } else {
      this.matchedCandidatesContainer.searchObject.requestSource = 'CONTACT';
      this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = this.isClearClicked ? false : true;
      this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
      this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails = this.isClearClicked ? false : true;
      delete this.matchedCandidatesContainer.searchObject.topMatches;
      this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
      this.displayAssociateCandidateSelectedFilter.topMatches = '';
      this.displayAssociateCandidateSelectedFilter.score = '';
      this.displayAssociateCandidateSelectedFilter.searchText = this.matchedCandidatesContainer.searchObject.searchText;
      this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
      this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
      this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
      this.sortRequisitions('Score Desc', 'Score', 'Desc');
    }

    this.onNoAdditionalChange();
    this.searchForMatchingCandidates();
  }

  private _restoreMatchScoreSlider() {
    const searchObject = this.matchedCandidatesContainer.searchObject;
    this._createMatchScoreSlider();
    $('#matchScoreSlider').val([searchObject.minimumScore, searchObject.maximumScore]);
  }

  private _createMatchScoreSlider() {
    this.minimumScoreSliderPadding = this.jobDetails.fourDotFiveIntelligenceScore < 65 ? this.jobDetails.fourDotFiveIntelligenceScore : (this.jobDetails.fourDotFiveIntelligenceScore - 4);
    const sliderId = '#matchScoreSlider';
    $(sliderId).empty();
    $(sliderId).noUiSlider({
      range: [0.00, 100.00],
      start: [this.jobDetails.fourDotFiveIntelligenceScore, 100],
      margin: 1.00,
      handles: 2,
      connect: true,
      step: 1,
      slide: () => {
        const val = $(sliderId).val();
        this.matchedCandidatesContainer.searchObject.minimumScore = parseInt(val[0], 10);
        this.matchedCandidatesContainer.searchObject.maximumScore = parseInt(val[1], 10);
        this.minimumScoreSliderPadding = this.matchedCandidatesContainer.searchObject.minimumScore < 65 ? this.matchedCandidatesContainer.searchObject.minimumScore : (this.matchedCandidatesContainer.searchObject.minimumScore - 4);
        this.maximumScoreSliderPadding = this.matchedCandidatesContainer.searchObject.maximumScore < 65 ? this.matchedCandidatesContainer.searchObject.maximumScore : (this.matchedCandidatesContainer.searchObject.maximumScore - 4);
        if (this.matchedCandidatesContainer.searchObject.minimumScore > 9 && this.matchedCandidatesContainer.searchObject.maximumScore - this.matchedCandidatesContainer.searchObject.minimumScore >= 0 && this.matchedCandidatesContainer.searchObject.maximumScore - this.matchedCandidatesContainer.searchObject.minimumScore <= 8) {
          this.maximumScoreSliderTopPosition = 80;
        } else {
          this.maximumScoreSliderTopPosition = 65;
        }
        $('#matchScoreSliderDisplayMinValue').addClass('job-match-score-slider-highlight-score');
        $('#matchScoreSliderDisplayMaxValue').addClass('job-match-score-slider-highlight-score');
        this.changeDetectorRef.detectChanges();
        this.isFiltersChanged = true;
        this.displayAssociateCandidateSelectedFilter.score = this._setJobMatchScoreDisplayFilter(this.matchedCandidatesContainer.searchObject.minimumScore, this.matchedCandidatesContainer.searchObject.maximumScore);
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
      },
      set: () => {
        const val = $(sliderId).val();
        this.matchedCandidatesContainer.searchObject.minimumScore = parseInt(val[0], 10);
        this.matchedCandidatesContainer.searchObject.maximumScore = parseInt(val[1], 10);
        $('#matchScoreSliderDisplayMinValue').removeClass('job-match-score-slider-highlight-score');
        $('#matchScoreSliderDisplayMaxValue').removeClass('job-match-score-slider-highlight-score');
      }
    });
    $(".noUi-origin.noUi-origin-upper").css('background', '#eee');
  }

  searchForMatchingCandidates() {
    this.isFiltersChanged = false;
    this.isDisplayRateFilterActive = this.matchedCandidatesContainer.searchObject.rate && this.matchedCandidatesContainer.searchObject.rate != "" ? true : false;
    if (this.candidateFilterItemsSelected.length === 0) {
      this.displayCandidateFilterFlag = false;
      this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon = true;
    }
    if (this.matchedCandidatesContainer && this.matchedCandidatesContainer.currentPromise && this.matchedCandidatesContainer.currentPromise.$$state) {
      if (this.matchedCandidatesContainer.currentPromise.$$state.status == 0) {
        this.genericService.cancelRequest(this.matchedCandidatesContainer.currentPromise);
      }
    }
    this.matchedCandidatesContainer.candidatesExistFlag = true;
    this.matchedCandidatesContainer.searchObject.page = 1;
    this.selectAllCandidatesFlag = false;
    this.matchedCandidatesContainer.candidates = [];
    this.matchedCandidatesContainer.totalCandidateCount = null;
    this.matchedCandidatesContainer.selectAllDoneFlag = false;
    this.matchedCandidatesContainer.disableInfiniteScroll = false;
    setTimeout(() => {
      this.isFiltersChanged = false;
      this.matchedCandidatesContainer.getNext();
    }, 200);
  }

  associateCandidates() {
    this.matchedCandidatesContainer.selectedCandidates.forEach((val: any) => {
      this.createJobMatchesObject.candidateIds.push(val.id);
    });
    this.savingFlag = true;
    const associatingDialog = this.alertsAndNotificationsService.showLoadingDialog('Associating Candidates');
    this._associateCandidates(this.matchedCandidatesContainer.selectedCandidates, () => {
      associatingDialog.modal('hide');
    });
  }

  private _associateCandidates(allSelectedCandidates: any[], successCallback: () => void) {
    const selectedCandidates = [...allSelectedCandidates];
    this.jobMatchService.createJobMatches(this.createJobMatchesObject, (data: any) => {
      this.savingFlag = false;
      if (successCallback) {
        successCallback();
      }
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      this.alertsAndNotificationsService.showAlertWithCallBack("Success!", "Candidate(s) associated successfully.", "success", () => {
        if (this.saveCallback) {
          this.saveCallback.emit();
        }
        setTimeout(() => {
          this.sendOutreachEmailToCandidates(selectedCandidates);
        }, 500);
      });
    }, (error: any) => {
      this.savingFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  jobCompare(candidate: any) {
    const actionObject = new JobMatchAction("Candidate Job Comparison", "CANDIDATE_JOB_COMPARE", true, null);
    candidate.jobMatchJobId = this.jobId;
    this.jobMatchActionsService.performAction('associateCandidates', actionObject, candidate, () => {
    }, () => {
    });
  }

  onNoAdditionalChange() {
    if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails) {
      const selectDefault = (list: any[], name: string) => {
        const item = list.find((i: any) => i.name === name);
        return item ? { ...item, ticked: true } : [];
      };

      if (this.selectedWorkLocations.length === 0 || !this.selectedWorkLocations.some((item: any) => item && item.name === 'No Work Location')) {
        this.workLocations.forEach((workLocation: any) => {
          if (workLocation.name == 'No Work Location') {
            workLocation.ticked = true;
          }
        });
        this.selectedWorkLocations.push(selectDefault(this.workLocations, 'No Work Location'));
        this.onWorkLocationSelected();
      }

      if (this.selectedJobTypeList.length === 0 || !this.selectedJobTypeList.some((item: any) => item && item.name === 'No Pref. Job Type')) {
        this.jobTypeList.forEach((jobType: any) => {
          if (jobType.name == 'No Pref. Job Type') {
            jobType.ticked = true;
          }
        });
        this.selectedJobTypeList.push(selectDefault(this.jobTypeList, 'No Pref. Job Type'));
        this.onJobTypeSelected();
      }

      if (this.selectedWorkAuthorizationList.length === 0 || !this.selectedWorkAuthorizationList.some((item: any) => item && item.name === 'No Work Authorization')) {
        this.workAuthorizationList.forEach((workAuth: any) => {
          if (workAuth.name == 'No Work Authorization') {
            workAuth.ticked = true;
          }
        });
        this.selectedWorkAuthorizationList.push(selectDefault(this.workAuthorizationList, 'No Work Authorization'));
        this.onWorkAuthorizationSelected();
      }
    } else {
      this.selectedWorkLocations = this.selectedWorkLocations.filter((workLocation: any) => workLocation.id != 'NO_WORK_LOCATION');
      this.workLocations.forEach((workLocation: any) => {
        if (workLocation.name == 'No Work Location') {
          workLocation.ticked = false;
        }
      });
      this.onWorkLocationSelected();

      this.selectedJobTypeList = this.selectedJobTypeList.filter((workLocation: any) => workLocation.name != 'No Pref. Job Type');
      this.jobTypeList.forEach((jobType: any) => {
        if (jobType.name == 'No Pref. Job Type') {
          jobType.ticked = false;
        }
      });
      this.onJobTypeSelected();

      this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter((workLocation: any) => workLocation.name != 'No Work Authorization');
      this.workAuthorizationList.forEach((workAuth: any) => {
        if (workAuth.name == 'No Work Authorization') {
          workAuth.ticked = false;
        }
      });
      this.onWorkAuthorizationSelected();
    }
    this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
    this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
    this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
  }

  setIsResumeRequiredForWorkflowMessage(candidate: any) {
    if (this.resumeRequiredForWorkflow && !candidate.resumeExist) {
      return `<p class="font-bold text-danger">Since this requisition requires candidates with resumes, after association, any candidate without resumes must have their resumes uploaded in the workflow.</p>`;
    } else {
      return '';
    }
  }

  private _setSalaryOrRateNotSpecified(type: string) {
    const isNoPrefJobTypeSelected = this.selectedJobTypeList.some((item: any) => item && item.value === 'NO_PREF_JOBTYPE');
    if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails ||
      (!this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails && isNoPrefJobTypeSelected)) {
      this.isDisplayRateFilterActive = true;
      if (type === 'rate' && this.matchedCandidatesContainer.searchObject.rate) {
        return " OR Rate = Not Specified";
      } else if (type === 'salary' && this.matchedCandidatesContainer.searchObject.salary) {
        return " OR Salary = Not Specified";
      }
    } else {
      return "";
    }
  }

  private _getBasicCandidateInfo(candidate: any): any {
    const basicCandidateInfo: any = {};
    basicCandidateInfo.name = candidate.contact.firstname + ' ' + candidate.contact.lastname;
    basicCandidateInfo.id = candidate.id;
    basicCandidateInfo.email = candidate.contact.email;
    basicCandidateInfo.mobilePhone = candidate.contact.mobilephone;
    basicCandidateInfo.workPhone = candidate.contact.workphone;
    basicCandidateInfo.matchScore = candidate.matchScore;
    basicCandidateInfo.candidateStatus = candidate.candidateStatus;
    if (candidate.lastModifiedDate !== null) {
      basicCandidateInfo.lastModifiedDate = new Date(candidate.lastModifiedDate);
    }
    basicCandidateInfo.candidateJobMatches = [];
    basicCandidateInfo.jobMatchesPopoverPosition = 'bottom';
    if (basicCandidateInfo.matchScore === null) {
      basicCandidateInfo.matchScore = 'N/A';
    } else {
      basicCandidateInfo.intelligenceScorePassFlag = false;
      if (basicCandidateInfo.matchScore >= this.jobDetails.fourDotFiveIntelligenceScore) {
        basicCandidateInfo.intelligenceScorePassFlag = true;
      }
      basicCandidateInfo.matchScore = Math.floor(parseFloat(basicCandidateInfo.matchScore));
    }
    basicCandidateInfo.allowManualMatch = candidate.allowManualMatch;
    basicCandidateInfo.showOverride = candidate.showOverride;
    basicCandidateInfo.allowOverride = candidate.allowOverride;
    basicCandidateInfo.reasonForNoManualMatch = candidate.reasonForNoManualMatch;
    basicCandidateInfo.releaseDate = candidate.releaseDate;
    basicCandidateInfo.suspendedMonths = candidate.suspendedMonths;
    basicCandidateInfo.releasedCandidateDetail = candidate.releasedCandidateDetail;
    basicCandidateInfo.jobLeftDetail = candidate.jobLeftDetail;
    basicCandidateInfo.overrideFor = candidate.overrideFor;
    basicCandidateInfo.resumeExist = candidate.resumeExist;
    basicCandidateInfo.matchingMandatoryCriteria = candidate.matchingMandatoryCriteria;
    return basicCandidateInfo;
  }

  sendOutreachEmailToCandidates(selectedCandidates: any[]) {
    let windowClass = 'four-dot-five-modal-small';
    const validCandidatesToSendOutreachEmail: any[] = [];
    const notValidCandidatesToSendOutreachEmail: any[] = [];
    let selectedJobMatchesForOutreach: any[] = [];
    let isSingleCandidateSelected = false;
    let candidateId = '';
    let candidateType = '';
    const companyId = this.companyId;
    const userId = this.userId;
    selectedCandidates.map((candidate: any) => {
      const tempObject: any = {};
      tempObject.jobMatchId = "";
      tempObject.candidateId = candidate.id;
      tempObject.workflowStepName = "";
      tempObject.candidateName = candidate.name;
      tempObject.message = "";
      tempObject.selected = true;
      tempObject.candidateType = candidate.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
      if (!candidate.email) {
        tempObject.message = "Email ID not available.";
        notValidCandidatesToSendOutreachEmail.push(tempObject);
      } else {
        validCandidatesToSendOutreachEmail.push(tempObject);
        if (selectedCandidates.length == 1) {
          selectedJobMatchesForOutreach = [...selectedCandidates];
        }
      }
    });
    isSingleCandidateSelected = selectedCandidates.length == 1 && validCandidatesToSendOutreachEmail.length == 1 ? true : false;
    if (isSingleCandidateSelected) {
      selectedJobMatchesForOutreach[0].candidateJobMatches.forEach((jobMatch: any) => {
        jobMatch.requisitionNumber = jobMatch.requisitionNumber;
        jobMatch.jobTitle = jobMatch.title;
        jobMatch.companyName = jobMatch.company;
        jobMatch.jobLocationText = this.jobMatchService.setJobLocationText(jobMatch.jobLocation);
        jobMatch.jobId = jobMatch.jobId;
        selectedJobMatchesForOutreach[0].candidateId = selectedJobMatchesForOutreach[0].id;
        candidateType = candidateType != '' ? candidateType : jobMatch.candidateType;
      });
      windowClass = 'four-dot-five-modal-large';
      candidateId = selectedJobMatchesForOutreach[0].id;
      selectedJobMatchesForOutreach[0].activeJobId = this.jobId;
    }
    const label = isSingleCandidateSelected ? `Send outreach to Candidate <b>'${selectedJobMatchesForOutreach[0].name}'</b>` : "Send outreach to Candidates";
    const vm = this;
    $(".modal").addClass("associate-candidate-modal");
    let bsModalRef: BsModalRef;
    const config = new ModalConfig();
    config.class = 'custom-modal-xl custom-candidate-profile-modal';
    config.initialState = {
      resolve: {
        validCandidatesToSendOutreachEmail,
        notValidCandidatesToSendOutreachEmail,
        label,
        isSingleCandidateSelected,
        companyId,
        userId,
        candidateId,
        clientOrBUId: vm.clientOrBuId,
        candidateType,
        selectedJobMatchesForOutreach,
        context: 'associateCandidates',
        jobId: vm.jobId,
        source: 'CANDIDATE_CARD'
      },
      modalInstance: {
        close: (callbackObject: any) => {
          bsModalRef.hide();
          if (callbackObject && callbackObject.callbackType === 'refresh') {
            vm.resetCandidateJobMatches();
          }
        },
        dismiss: () => {
          bsModalRef.hide();
        }
      }
    };
    bsModalRef = this.bsModalService.show(CandidateSendOutreachEmailModalComponent, config);
  }

  getFilteredSelectedCandidates(): any[] {
    if (!this.matchedCandidatesContainer) {
      return [];
    }
    const searchText = (this.selectedCandidatesSearchText || '').toLowerCase();
    const candidates = [...this.matchedCandidatesContainer.selectedCandidates].sort((a: any, b: any) => {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    });
    if (!searchText) {
      return candidates;
    }
    return candidates.filter((candidate: any) => candidate.name && candidate.name.toLowerCase().indexOf(searchText) !== -1);
  }

  private resetCandidateJobMatches() {
    // placeholder retained for parity with legacy no-op reference (candidate job matches refresh not required here)
  }
}
